import { axiosGet, axiosPost } from "../../../../../react_axios/Axios";
import { INSERT_AND_UPDATE_LEAD_RETRIEVAL_FORM_ACTION_TYPE, GET_LEAD_RETRIEVAL_FORM_DETAILS_ACTION_TYPE, headers, insertUpdateLeadRetrievalFormUrl, getLeadRetrievalFormDetailsUrl } from "../../../../../utils/constants";



export const insertUpdateLeadRetrievalForm_action = (Name, Designation, MobileNo, Email, Quantity, Remark, Is_Agree) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS'),
            Name: Name,
            Designation: Designation,
            MobileNo: MobileNo,
            Email: Email,
            Quantity: Quantity,
            // is_outlet: is_outlet,
            // is_inlet: is_inlet,
            Remark: Remark,
            Is_Agree: Is_Agree,
        }
        const res = await axiosPost(insertUpdateLeadRetrievalFormUrl, params, headers)

        dispatch({
            type: INSERT_AND_UPDATE_LEAD_RETRIEVAL_FORM_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getLeadRetrievalFormDetails_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS'),
        }
        const res = await axiosGet(getLeadRetrievalFormDetailsUrl, params, headers)

        dispatch({
            type: GET_LEAD_RETRIEVAL_FORM_DETAILS_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}